import { AdvertisementService } from './../../../Services/advertisement.service';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA } from '@angular/material';
import { DialogLoginComponent } from './../../../Dialogs/dialog.login/dialog.login.component';
import { MatDialogRef } from '@angular/material';
import { UserService } from './../../../Services/user.service';
import { MainService } from './../../../Services/service.service';
import { Component, OnInit, Inject } from '@angular/core';
import {Location} from '@angular/common';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent extends DialogLoginComponent  {

  view: LoginView = 0;
  loading: boolean = false;

  constructor(fb: FormBuilder, public service: MainService, private _location: Location, public userService: UserService, public route: Router, private advService: AdvertisementService) {
    super(fb, undefined, null, service);
  }

  get passwordInput(): any { return this.loginForm.get('password'); }

  changeView(view: number) {
    this.view = view;
  }

  locationBack() {
    this._location.back();
  }

  ngOnInit(): void {
    if (this.userService.isAuthenticated()) {
      this.service.route.navigate(["/account/"])
    }
  }

  onSubmit() {
    this.validateAllFormFields(this.loginForm)
    if (!this.loginForm.invalid) {
      if (!this.isCaptchaOk()) {
        this.service.showError("Please confirm the captcha");
      }else{
        if (this.userService.isAuthenticated()) {
          return;
        } else {
            const email = this.loginForm.controls["email"].value;
            const password = this.loginForm.controls["password"].value;
            this.loading = true;
            this.userService.login(email,password,this.loginForm.controls["rememberme"].value,undefined)
            .then(r => {
              this.loading = false;
    
              // if (this.route.url == "/register") {
              //   if (url) this.route.navigate(["main"]);
              // } else {
              //   if (url) this.route.navigate([url]);
              // }
    
              this.advService.searchDataUserAdv.currentSearchRule.userId = this.userService.getUserId();
              this.advService.searchActionForUser();
    
              this.route.navigate([""]);
            })
            .catch(e => {
              this.loading = false;
              this.service.showError(e);
            });
          };
      }
    }
  }

}

enum LoginView { LoginRegister = 0, Login = 0 }
